export default __webpack_public_path__ + "static/media/careers-hero.96baaf46.jpg";